import React from 'react';

import { useAudioPlayerStore } from '@atlassian/ai-audio';
import { useAudioPlayerIframeListener } from '@atlassian/ai-audio/hooks/iframe-listener';

import { LoadableLazy } from '@confluence/loadable';
import { type WithFlagsProps, withFlags } from '@confluence/flags/entry-points/withFlags.ts';

type FloatingAudioContainerWrapperProps = {} & WithFlagsProps;

const FloatingAudioContentLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FloatingAudioContent" */
				'./FloatingAudioContent.tsx'
			)
		).FloatingAudioContent,
});

export const FloatingAudioContainer: React.ComponentType<Omit<unknown, 'flags'>> = withFlags(
	({ flags }: FloatingAudioContainerWrapperProps) => {
		const { isOpen } = useAudioPlayerStore();

		useAudioPlayerIframeListener();

		return isOpen ? <FloatingAudioContentLoadable flags={flags} /> : null;
	},
);
